import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import axiosInstance from "../../../api";
import { useOktaAuth } from "@okta/okta-react";
import Action from "../../../models/API/responseModels/sectionActionsDataResponse.model";

function useSectionsActions(): UseQueryResult<AxiosResponse<Action[]>, any> {
 const oktaAuth = useOktaAuth();

 return useQuery({
  queryKey: ["sectionActions"],
  queryFn: () =>
   axiosInstance
    .get(`v1/section-action`, {
     headers: {
      Authorization: `Bearer ${oktaAuth?.authState?.accessToken?.accessToken}`,
     },
    })
    .then((res) => res.data),
  enabled: !!oktaAuth?.authState?.accessToken?.accessToken,
 });
}

export default useSectionsActions;
